import {
  ShopifyProductCollectionSortKeys,
  type sfCollection,
  type UnlikelyPageInfo,
} from "@unlikelystudio/commerce-connector"

import {
  getCollectionMetafieldProccessedKeys,
  getProductMetafieldProccessedKeys,
  getVariantMetafieldProccessedKeys,
} from "~/lib/shopify/constants/metafields"

// Filters
export const SHOPIFY_FILTERS_SORT_BY_KEYS = ["default", "price_asc", "price_desc", "best_selling"] as const

export type SHOPIFY_FILTERS_SORT_KEYS = (typeof SHOPIFY_FILTERS_SORT_BY_KEYS)[number]

export const SHOPIFY_FILTERS_SORT_BY: Record<
  SHOPIFY_FILTERS_SORT_KEYS,
  Pick<Parameters<typeof sfCollection>[1], "productsSortKey" | "productReverse">
> = {
  default: {
    productsSortKey: ShopifyProductCollectionSortKeys.CollectionDefault,
    productReverse: false,
  },
  price_asc: {
    productsSortKey: ShopifyProductCollectionSortKeys.Price,
    productReverse: false,
  },
  price_desc: {
    productsSortKey: ShopifyProductCollectionSortKeys.Price,
    productReverse: true,
  },
  best_selling: {
    productsSortKey: ShopifyProductCollectionSortKeys.BestSelling,
    productReverse: false,
  },
} as const

export const SORT_BY_PARAM = "sort"

export const DEFAULT_PAGE_INFO: UnlikelyPageInfo = {
  endCursor: null,
  startCursor: null,
  hasNextPage: false,
  hasPreviousPage: false,
}

export const DEFAULT_COLLECTION_QUERY_PARAMS = {
  includeProductsFilters: true,
  includePrices: true,
  includeImage: true,
  imagesFirst: 2,
  // WARNING :
  // The less variants we need, the better.
  // It was set previously to 250, but it was causing a lot of performance issues.
  // We should try to keep this number as low as possible.
  // Info : We set it to 1 here just because only one variant is needed in the serializeViewItemPayload function
  variantsFirst: 1,
  // We just need only 1 component to know if the product is a bundle.
  variantComponentsFirst: 1,
  metafieldKeys: getCollectionMetafieldProccessedKeys(
    "MATERIALS_PANEL",
    "REMOVE_FROM_BREADCRUMB",
    "EXCLUDED_FILTERS_BY_MARKETS"
  ),
  metafieldProductsKeys: getProductMetafieldProccessedKeys(
    "TAG",
    "SUBTITLE",
    "CUSTOM_DEFAULT_IMG",
    "CUSTOM_DEFAULT_IMG_HOVER",
    "BUNDLE_HIDE_FROM_PRICE_LABEL",
    "ASSOCIATED_PRODUCTS",
    "DISPLAY_NAME",
    "PRODUCT_COLOR"
  ),
  collectionsFirst: 3,
  metafieldVariantsKeys: getVariantMetafieldProccessedKeys("HIDDEN_ON_MARKET"),
}
